module.exports = __webpack_public_path__ + "e9c52ad0662ff6c5fb25fec1f963c390.pdf";